import { get, put } from "../helpers/directApi";

/**
 * Account profile API.
 *
 * directApi rather than the shared client, because saving a display name now
 * fails for reasons the member has to be able to tell apart: the name is taken,
 * it has characters that are not allowed, it is reserved. The shared client's
 * interceptor rejects with a string and prefers the body's `error` field over
 * its `message`, so all three arrived as the raw code — "name_taken" shown to
 * a member as if it were a sentence.
 *
 * Each call still resolves to the response body, so callers' success paths are
 * unchanged.
 */

// The signed-in user's record (includes is_admin).
export const getProfile = () => get("/api/user/profile");

// Set the display name; resolves to the updated user record.
export const updateDisplayName = (displayName) =>
  put("/api/user/profile", { display_name: displayName });

/**
 * Mirror the saved name into the stored session so the header updates without
 * a re-login. display_name is what the header prefers; the real-name fields
 * come along so the fallback stays accurate.
 */
export const syncStoredUser = (user) => {
  try {
    const raw = localStorage.getItem("authUser");
    if (!raw) return;
    const stored = JSON.parse(raw);
    localStorage.setItem(
      "authUser",
      JSON.stringify({
        ...stored,
        display_name: user.display_name,
        first_name: user.first_name,
        last_name: user.last_name,
        username: user.username,
      })
    );
  } catch {
    // A malformed session is not worth failing the save over — the name is
    // already persisted server-side and will be correct on next login.
  }
};
